import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';
import Currencies from '../Currencies.js';
export default class MembresiasMovimientos {
    static typeSearch      = "local" //online || local

    constructor(data = null) {
        this.Id            = (data?.Id)?data.Id:null;
        this.FechaCreacion = (data?.FechaCreacion)?data.FechaCreacion:null;
        this.Tipo          = (data?.Tipo)?data.Tipo:"P";
        this.Cantidad      = (data?.Cantidad)?data.Cantidad:{M:Currencies.getCurrencyDefault(),C:0};
        this.ConceptoCode  = (data?.ConceptoCode)?data.ConceptoCode:"";
        this.Concepto      = (data?.Concepto)?data.Concepto:"";
        this.Periodo       = (data?.Periodo)?data.Preiodo:""
        this.MPago         = (data?.MPago)?data.MPago:"";
        this.NTransaccion  = (data?.NTransaccion)?data.NTransaccion:"";
        this.Membresia     = (data?.Membresia)?data.Membresia:null;
        this.Fecha         = (data?.Fecha)?data.Fecha:moment().format("YYYY-MM-DD");
        this.Pagos         = (data?.Pagos)?data.Pagos:{}
        /*Pagos = {
            AMEX:{
                Cantidad:{},
                Referncia:{}
            }
        }*/
    }

    static getPropertyModel(){
        let model = new MembresiasMovimientos();
        return model;
    }


}